import {ConstantForNFirstInstallmentRateStrategyConfig, RateStrategyConfig} from '../types';
import * as React from 'react';
import {MouseEventHandler} from 'react';
import {PercentDisplay} from '../application/components/PercentDisplay';
import Box from '@mui/material/Box';
import {StandOutText} from '../application/components/StandOutText';

export type RateStrategyDisplayProps = {
    rateStrategyConfig: RateStrategyConfig;
    onClick?: MouseEventHandler<any>;
};

const noOp: MouseEventHandler<any> = () => {};

function isConstantForNFirstInstallment(
    config: RateStrategyConfig
): config is ConstantForNFirstInstallmentRateStrategyConfig {
    return (
        (config as ConstantForNFirstInstallmentRateStrategyConfig).__typename ===
        'ConstantForNFirstInstallmentRateStrategyConfig'
    );
}

export function RateStrategyDisplay({rateStrategyConfig, onClick = noOp}: RateStrategyDisplayProps) {
    function convertToElement() {
        if (isConstantForNFirstInstallment(rateStrategyConfig)) {
            return (
                <>
                    Oprocentowanie stałe{' '}
                    <StandOutText>
                        <PercentDisplay rate={rateStrategyConfig.constantRate} />
                    </StandOutText>
                    , po{' '}
                    <StandOutText>{rateStrategyConfig.becomesVariableRateAfterNInstallments} miesiącach</StandOutText>{' '}
                    zmienne z marżą{' '}
                    <StandOutText>
                        <PercentDisplay rate={rateStrategyConfig.variableRateMargin} />
                    </StandOutText>
                </>
            );
        }
        return <></>;
    }

    return (
        <Box onClick={onClick} sx={{flex: 1, minWidth: 0, fontSize: '0.8125rem', color: 'text.secondary'}}>
            {convertToElement()}
        </Box>
    );
}
